<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/treasury')" style="cursor: pointer">Tesorería</li>
        <li class="breadcrumb-item active" aria-current="page">Ejecución de beneficiarios</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vx-card>
        <h3>Ejecución de beneficiarios</h3>
        <!-- PARAMETROS DE BUSQUEDA -->
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/3">
            <vs-input color="dark" class="w-full" label="Id del inversionista fallecido" v-model="inputSearch" />
          </div>
          <div class="vx-col w-full lg:w-1/3">
            <vs-input color="dark" class="w-full" label="Id del inversionista beneficiario"
              v-model="inputBeneficiarySearch" />
          </div>
          <div class="vx-col w-full lg:w-1/3">
            <div class="flex flex-wrap">
              <vs-button :disabled="(!inputSearch || !inputBeneficiarySearch)" @click="searchUserData" color="dark"
                class="mt-6 btn-rgprimary">Continuar</vs-button>
              <vs-button :disabled="!allStepsCompleted" @click="confirmTransfer()" color="primary"
                class="ml-3 mt-6 btn-rgprimary">Traspasar</vs-button>
              <vs-button @click="closeAccountRequest()" color="danger" :disabled="!inputSearch"
                class="ml-3 mt-6 btn-rgprimary">Cerrar cuenta</vs-button>
            </div>
          </div>
        </div>
      </vx-card>

      <div v-if="onError" class="vx-row">
        <div class="vx-col w-full ">
          <vs-alert icon-pack="feather" active="true" icon="icon-info" color="danger" class="mt-3" style="height: auto">{{
            errorMssg }}</vs-alert>
        </div>
      </div>

      <template v-if="resultDataResponse">
        <!-- RESPUESTA DE BUSQUEDA -->
        <vs-alert v-if="!resultDataResponse.isInvestorValid" icon-pack="feather" class="mt-5" icon="icon-info" color="danger" active="true">
          <span>El id del inversionista fallecido no existe, verifica tus datos.</span>
        </vs-alert>
        <vs-alert v-else-if="!resultDataResponse.isBeneficiaryInvestorValid" icon-pack="feather" class="mt-5" icon="icon-info" color="danger" active="true">
          <span>El id del inversionista beneficiario no existe, verifica tus datos.</span>
        </vs-alert>
        <template v-else>
          <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
              <vx-card class="h-auto text-center mt-5">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <h3 class="mt-5 mb-3">
                      {{ explicitMoneyFormat(resultDataResponse.availableToInvest) }} MXN
                    </h3>
                    <label>
                      Saldo disponible
                    </label>
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
              <vx-card class="h-auto text-center mt-5">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <h3 class="mt-5 mb-3">
                      {{ explicitMoneyFormat(resultDataResponse.investmentCommitments) }} MXN
                    </h3>
                    <label>
                      Compromisos de inversión
                    </label>
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
              <vx-card class="h-auto text-center mt-5">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <h3 class="mt-5 mb-3">
                      {{ explicitMoneyFormat(resultDataResponse.activeFixedInvestment) }} MXN
                    </h3>
                    <label>
                      Inversión efectiva
                    </label>
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
              <vx-card class="h-auto text-center mt-5">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <h3 class="mt-5 mb-3">
                      {{ explicitMoneyFormat(resultDataResponse.totalPortfolio) }} MXN
                    </h3>
                    <label>
                      Valor del portafolio
                    </label>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card class="mt-5">
                <template v-if="resultDataResponse.beneficiaries.length > 0">
                  <div class="vx-row">
                    <div class="vx-col w-full md:w-2/3">
                      <h4>Beneficiarios del inversionista</h4>
                      <p class="mb-2 mt-2">
                        Selecciona el beneficiario que recibirá la información del inversionista.
                      </p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <h4>No existen beneficiarios registrados</h4>
                  </div>
                </template>
                <div class="data-list-container data-list-list-view data-list-high-rows vs-con-loading__container"
                  id="main-div">
                  <vs-table ref="table" pagination max-items="10" :data="resultDataResponse.beneficiaries"
                    noDataText="No hay datos disponibles" @selected="onBeneficiarySelected">
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                    <template slot="thead">
                      <vs-th v-for="(col, idx) in columns" v-bind:key="idx"
                        :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                        <vs-td>
                          {{ tr.complete_name }}
                        </vs-td>
                        <vs-td>
                          {{ dateStr(tr) }}
                        </vs-td>
                        <vs-td>
                          {{ tr.email }}
                        </vs-td>
                        <vs-td>
                          {{ tr.phone }}
                        </vs-td>
                        <vs-td>
                          {{ percentageFormat(tr) }}
                        </vs-td>
                        <vs-td>
                          <div class="flex flex-wrap">
                            <feather-icon icon="EyeIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="mr-6"
                              @click.stop="showItemRequest(tr)" />
                            <span v-if="!isBeneficiarySelected(tr)" class="text-sm text-primary">Seleccionar</span>
                            <span v-if="isBeneficiarySelected(tr)" class="flex items-center">
                              <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 text-success" class="mr-2" />
                              <span class="text-sm text-success bold">Elegido</span>
                            </span>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
              <vx-card class="mt-5" title="Acta-Certificado de defunción">
                <document-upload-lite :accepts="['pdf', 'png', 'jpg', 'jpeg']" upload-type="signed"
                  name="Acta-Certificado de defunción" :check-url="checkUrl" :view-url="viewUrl"
                  :download-url="downloadUrl" :upload-url="uploadUrl" width="1" />
              </vx-card>
            </div>
          </div>
        </template>
      </template>

      <vs-popup class="extended-popup" title="Datos de beneficiario" :active.sync="isBeneficiaryDetailPopupActive"
          v-if="isBeneficiaryDetailPopupActive">
          <beneficiary-detail :id="showBeneficiaryId" />
        </vs-popup>

        <vs-popup class="small-popup" title="¿Desea continuar con la operación?" :active.sync="isConfirmTransferPopupActive"
          v-if="isConfirmTransferPopupActive">
            <h3>Se realizará lo siguiente:</h3>
            <label>-Se reembolsarán los compromisos de inversión al IID: {{ inputSearch }}</label>
            <label>-Se transferirá el saldo disponible al beneficiario</label>
            <label>-Se traspasará la inversión efectiva al IID: {{ inputBeneficiarySearch }}</label>
            <label>-Se realizará el cierre de cuenta del IID: {{ inputSearch }}</label>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex flex-wrap items-center justify-end align-right">
                  <vs-button @click="isConfirmTransferPopupActive=false" color="danger"
                    class="mt-6 btn-rgprimary">Cancelar</vs-button>
                  <vs-button @click="executeTransfer()" color="primary"
                    class="ml-3 mt-6 btn-rgprimary">Confirmar</vs-button>
                </div>
              </div>
            </div>
        </vs-popup>

        <vs-popup :active.sync="cancellationAccountNotValid" title="Cierre de cuenta">
          <div class="p-3 pt-1">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h5>No es posible proceder con el cierre de cuenta.</h5>
                <p class="mt-4 mb-5">
                  No es posible iniciar el proceso de cierre de la cuenta, debido a que existen una o más condiciones que lo
                  impiden:
                </p>

                <p class="bold mb-3" v-for="(validation, idx) in cancellationAccountValidations" :key="idx">
                  - {{ validation }}
                </p>
              </div>
              <div class="vx-col w-full mt-3">
                <div class="flex items-center flex-grow justify-end mt-1">
                  <vs-button color="dark" @click.stop="cancellationAccountNotValid = false">Cerrar</vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-popup>
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import formHelper from "@mixins/formHelper";
import dateHelper from '@mixins/dateHelper';
import BeneficiaryDetail from "@components/profile_shared/BeneficiaryDetail";
import DocumentUploadLite from "@components/misc/DocumentUploadLite";

const columnDefinitions = [
  { title: "Nombre completo", key: "complete_name", sortable: true },
  { title: "Fecha de nacimiento", key: "birth_date", sortable: true },
  { title: "Correo electrónico", key: "email", sortable: true },
  { title: "Teléfono", key: "phone", sortable: true },
  { title: "Porcentaje", key: "percentage", sortable: true },
  { title: "Acciones", key: "", sortable: false },
];

export default {
  name: 'TransferToBeneficiaries',
  mixins: [formatHelper, dateHelper, formHelper],
  data() {
    return {
      showFixedInvestmentChart: false,
      inputSearch: null,
      inputBeneficiarySearch: null,
      beneficiaryIdSelected: null,
      resultDataResponse: null,
      columns: columnDefinitions,
      showBeneficiaryId: null,
      isBeneficiaryDetailPopupActive: false,
      isConfirmTransferPopupActive: false,
      onError: false,
      errorMssg: null,
      cancellationAccountValidations: [],
      cancellationAccountNotValid: false,
    }
  },
  components: {
    BeneficiaryDetail,
    DocumentUploadLite
  },
  computed: {
    checkUrl() {
      if (this.inputSearch) {
        return `investor/${this.inputSearch}/death_certificate/info`;
      }
      return null;
    },
    viewUrl() {
      if (this.inputSearch) {
        return `investor/${this.inputSearch}/death_certificate/view`;
      }
      return null;
    },
    downloadUrl() {
      if (this.inputSearch) {
        return `investor/${this.inputSearch}/death_certificate/download`;
      }
      return null;
    },
    uploadUrl() {
      if (this.inputSearch) {
        return `investor/${this.inputSearch}/death_certificate/upload`;
      }
      return null;
    },
    allStepsCompleted() {
      return this.resultDataResponse?.isInvestorValid && this.resultDataResponse?.isBeneficiaryInvestorValid && this.beneficiaryIdSelected && this.resultDataResponse.totalPortfolio > 0;
    },
  },
  methods: {
    async searchUserData() {
      this.showLoading(true);
      this.cleanData();
      let payload = {
        current_investor_id: this.inputSearch,
        beneficiary_investor_id: this.inputBeneficiarySearch,
      };
      await axios.post(`/api/investor/data-transfer-to-beneficiaries`, payload).then(response => {
        this.resultDataResponse = response.data;
        this.showLoading(false);
      }).catch(error => {
        if (error.response) {
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error en la creación");
        }
        this.showLoading(false);
      });
    },
    dateStr(beneficiary) {
      return this.midDateFormat(beneficiary.birth_date);
    },
    showItemRequest(beneficiary) {
      this.showBeneficiaryId = beneficiary.id;
      this.isBeneficiaryDetailPopupActive = true;
    },
    percentageFormat(beneficiary) {
      let per = `${beneficiary.beneficiary_percentage * 100}%`
      return per;
    },
    onBeneficiarySelected(tr) {
      if (tr.id === this.beneficiaryIdSelected) {
        return;
      }
      else {
        this.beneficiaryIdSelected = tr.id
      }
    },
    isBeneficiarySelected(tr) {
      return tr.id === this.beneficiaryIdSelected;
    },
    runValidations() {
      if (this.inputSearch == this.inputBeneficiarySearch) {
        this.errorMssg = "Los ids de los inversionistas deben ser diferentes.";
        return false;
      }
      if (this.beneficiaryIdSelected === null) {
        this.errorMssg = "Debes seleccionar un beneficiario.";
        return false;
      }
      return true;
    },
    async confirmTransfer() {
      this.onError = false;
      this.errorMssg = null;
      let valid = this.runValidations();
      if (!valid) {
        this.onError = true;
        return;
      }
      this.isConfirmTransferPopupActive=true;
    },
    async executeTransfer() {
      this.showLoading(true);
      this.isConfirmTransferPopupActive=false;
      let payload = {
        current_investor_id: this.inputSearch,
        beneficiary_investor_id: this.inputBeneficiarySearch,
        beneficiary_id: this.beneficiaryIdSelected
      };
      await axios.post(`/api/investor/execute-transfer-to-beneficiaries`, payload).then(response => {
        this.successNotif("Aviso", "El traspaso ha sido exitoso");
        this.cleanData();
        this.showLoading(false);
      }).catch(error => {
        if (error.response) {
          this.errorNotifDialog("Aviso", error.response.data.message);
          this.searchUserData();
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error en la operación");
        }
        this.showLoading(false);
      });
    },
    async closeAccountRequest() {
      // solicitar datos de validacion de cierre de cuenta
      this.showLoading(true)
      try {
        const res = await axios.get(`api/v2/investor/${this.inputSearch}/checkAccountCancellationConditions`);
        const hasTrx = res.data.hasTrx;
        const activeProjsCount = res.data.activeProjsCount;
        const finalBalance = res.data.finalBalance;
        const planActive = res.data.planActive;
        const alreadyRequested = res.data.alreadyRequested;
        let validations = [];
        if (alreadyRequested) {
          this.errorNotifDialog('Proceso en ejecución', 'Ya se encuentra en proceso de cancelación la cuenta del inversionista.');
          this.showLoading(false);
          return;
        }
        if (finalBalance > 0) {
          validations.push('El inversionista aún tiene saldo en su cuenta.');
        }
        if (activeProjsCount > 0) {
          validations.push('El inversionista aún cuenta con proyectos que están activos, es decir, que están en proceso de fondeo, en instalación o en proceso de cobranza.');
        }
        if (planActive) {
          validations.push('El inversionista aún cuenta con un plan de inversión activo.')
        }
        if (validations.length > 0) {
          this.cancellationAccountValidations = validations;
          this.cancellationAccountNotValid = true;
        }
        else {
          let mssg = 'Confirma que deseas proceder con el cierre de la cuenta en RedGirasol.';
          this.confirmationDialog(
            this.doCancelAccount,
            'Confirma la acción',
            mssg,
            'Confirmar'
          );
        }
      }
      catch (e) {
        this.errorNotifDialog('Error en petición', 'No ha sido posible obtener la información, intente más tarde.');
      }
      this.showLoading(false)
    },
    async doCancelAccount() {
      this.showLoading(true)
      try {
        let payload = {};
        await axios.post(`api/v2/investor/${this.inputSearch}/doCancelAccount`, payload);
        this.successNotifDialog('Petición de cierre de cuenta', 'El proceso de cierre de cuenta ha sido iniciado correctamente.');
      }
      catch (e) {
        if (e && e.response && e.response.data && e.response.data.error) {
          this.errorNotifDialog('Error en petición', e.response.data.error);
        }
        else {
          this.errorNotifDialog('Error en petición', 'No ha sido posible obtener la información, intente más tarde.');
        }
      }
      this.showLoading(false)
    },

    cleanData() {
      this.resultDataResponse = null;
      this.onError = false;
      this.errorMssg = null;
      this.beneficiaryIdSelected = null;
    }
  }
}
</script>